import { render, staticRenderFns } from "./BloqueReto.vue?vue&type=template&id=37988404&scoped=true"
import script from "./BloqueReto.vue?vue&type=script&lang=js"
export * from "./BloqueReto.vue?vue&type=script&lang=js"
import style0 from "./BloqueReto.vue?vue&type=style&index=0&id=37988404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37988404",
  null
  
)

export default component.exports